import { PRODUCT_TABLE_TYPES } from '../../../lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.STANDARD;

const columns = (id) => [
  {
    name: 'Broker',
    elements: [
      {
        type: 'ApplyNow',
        props: {
          logoLink: true,
          impressionId: `logo-${id}`,
        },
      },
      {
        type: 'StarRating',
      },
      {
        type: 'ApplyNow',
        props: {
          ctaCopy: 'Learn More',
          hideIcon: true,
          impressionId: `cta-${id}`,
        },
      },
    ],
  },
  {
    name: 'Commissions',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactFees',
        },
      },
    ],
  },
  {
    name: 'Account Minimum',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactAccountMinimum',
        },
      },
    ],
  },
  {
    name: 'Current Offers',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactPromotion',
        },
      },
    ],
  },
  {
    name: 'Details',
    width: 300,
    elements: [
      {
        type: 'ProsAndCons',
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
